<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div>
    <p>{{ content }}</p>
    <div style="text-align: right; margin: 0; padding-top: 10px;">
      <el-button size="mini" class="wy-grey-button" @click="handleAction(false)">{{ $t(cancelLabelKey) }}</el-button>
      <el-button size="mini" class="wy-blue-button" @click="handleAction(true)">{{ $t(confirmLabelKey) }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wy-confirmation',
  props: {
    placement: {
      type: String,
      default: 'left'
    },
    width: {
      type: Number,
      default: 300
    },
    content: {
      type: String,
      default: ''
    },
    confirmLabelKey: {
      type: String,
      default: 'button.confirm'
    },
    cancelLabelKey: {
      type: String,
      default: 'button.cancel'
    },
    actionCallback: {
      type: Function,
      default: function() {}
    }
  },

  methods: {
    // open(target) {
    //   // close if open
    //   this.$refs.wyConfirmation.doClose();
    //   this.$refs.wyConfirmation.referenceElm = null;

    //   // clear delay open timeout
    //   if(this.$refs.wyConfirmation.timeoutOpen) {
    //     clearTimeout(this.$refs.wyConfirmation.timeoutOpen);
    //   }
    //   // delay open
    //   this.$refs.wyConfirmation.timeoutOpen = setTimeout(() => {
    //     this.$refs.wyConfirmation.referenceElm = target;
    //     this.$refs.wyConfirmation.doShow();
    //   }, 300)
    //   // clear delay close timeout
    //   if(this.$refs.wyConfirmation.timeoutClose) {
    //     clearTimeout(this.$refs.wyConfirmation.timeoutClose);
    //   }
    //   // // delay close
    //   // this.$refs.wyConfirmation.timeoutClose = setTimeout(() => {
    //   //   this.$refs.wyConfirmation.doClose();
    //   // }, 3000)
    // },

    // close() {
    //   // close if open
    //   this.$refs.wyConfirmation.doClose();
    //   this.$refs.wyConfirmation.referenceElm = null;
    // },

    handleAction(isConfirm) {      
      this.actionCallback(isConfirm);
      // this.$refs.wyConfirmation.doClose();
    }
  }
}
</script>

<style lang="scss">
// .wy-confirmation {
//   top: calc(30vh - 50px);
//   left: calc(50vw - 160px);
// }

</style>